exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mainItensCarousel{\n    width: 100%;\n}\n.mainItensCarousel .slick-track{\n    display: flex;\n    column-gap: 20px;\n}\n@media (max-width: 576px){\n.mainItensCarousel .slick-track{\n    column-gap: 5px;\n}\n}\n", ""]);

// exports
